<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="maintenance-create-lb-title">
      {{$t('maintenance.legal_basis.create.title')}}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-lb-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-lb-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-lb-name-label">
                  {{ $t('maintenance.legal_basis.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-lb-form-name"
                  type="text"
                  v-model="lbForm.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.legal_basis.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-lb-short-name-label">
                  {{ $t('maintenance.legal_basis.create.short_name_label') }}
                </label>
                <b-form-input
                  qid="create-lb-form-short-name"
                  type="text"
                  v-model="lbForm.short_name"
                  required
                  :placeholder="$t('maintenance.legal_basis.create.short_name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-lb-description-label">
                  {{ $t('maintenance.legal_basis.create.description_label') }}
                </label>
                <b-form-textarea
                  qid="create-lb-form-description"
                  v-model="lbForm.description"
                  rows="6"
                  required
                  max-rows="6"
                  :placeholder="$t('maintenance.legal_basis.create.description_placeholder')"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group :class="{'multiselect--show-input': categoryInput.length}">
                <label qid="create-lb-category-label">
                  {{ $t('maintenance.legal_basis.create.category_label') }}
                </label>
                <multiselect
                    v-model="lbForm.category"
                    :options="categoryItems"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('maintenance.legal_basis.create.category_placeholder')"
                    label="category"
                    :preserveSearch="true"
                    @search-change="handleCategoryInput"
                    qid="create-lb-form-category"
                >
                  <template slot="noResult" slot-scope="props">
                    {{ $t('maintenance.legal_basis.create.category_no_results') }}
                  </template>
                </multiselect>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-lb-cancel-button"
              >
                {{ $t('maintenance.legal_basis.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        variant="success"
                        :disabled="buttonDisabled"
                        qid="create-lb-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.legal_basis.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'CreateLegalBasis',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.legal_basis.title'),
            to: '/maintenance/legal-basis'
          },
          {
            text: this.$t('maintenance.legal_basis.create.title'),
            active: true
          }
        ],
        lbForm: {
          name: '',
          short_name: '',
          description: '',
          category: [],
          client:'',
        },
        error: '',
        categoryItems: [],
        categoryInput: '',
        buttonDisabled: false
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadCategories();
      }
    },
    methods: {
      goToList() {
        this.$router.push('/maintenance/legal-basis')
      },
      handleCategoryInput(input) {
        this.categoryInput = input;
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        formData.append("name", this.lbForm.name);
        formData.append("short_name", this.lbForm.short_name);
        formData.append("description", this.lbForm.description);
        formData.append("client", this.getClient.slug);

        // Additional check - if category is selected, append it to form data
        if (this.lbForm.category && this.lbForm.category.category) {
          formData.append("category", this.lbForm.category.category);
        } else {
          if (this.categoryInput && this.categoryInput.length) {
            formData.append("category", this.categoryInput);
          }
        }

        // Post FormData object to API
        piincHttp.post('/articles', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.buttonDisabled = false;
          self.$toastr('success', self.$t('maintenance.legal_basis.create.success'))
          self.goToList();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.category) {
              self.error += ' ' + error.data.errors.category[0]
            }
          }
        })
      },
      loadCategories() {
        let self = this;
        piincHttp.get('/articles/categories', { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.categoryItems = response.data
          if (self.categoryItems && !self.categoryItems.length) {
            self.categoryItems.push({category: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      }

    },
    components: {

    },
    created () {
      if (this.getClient && this.getClient.slug) {
        this.loadCategories();
      }
    }

  }
</script>
